import { Card, CardContent } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";

/**
 * `prototype-extracted.md § 2.6` `StrategyCardSkeleton` — the loading placeholder shown
 * while the Strategy tab is Fetching (`WEB-008`) or Building (the fallback scorecard read
 * still running). Structural only: `aria-hidden` so a screen reader skips it entirely, and
 * `pointer-events-none select-none` so it can never be focused, clicked or selected as text.
 */
export function StrategyCardSkeleton() {
  return (
    <Card className="border-border pointer-events-none select-none" aria-hidden="true">
      <CardContent className="p-6 space-y-6">
        <div className="flex items-start justify-between gap-4">
          <div className="space-y-2">
            <div className="flex items-center gap-2">
              <Skeleton className="h-4 w-4" />
              <Skeleton className="h-5 w-2/5" />
            </div>
            <div className="flex items-center gap-2">
              <Skeleton className="h-3 w-32" />
              <Skeleton className="h-3 w-24" />
            </div>
          </div>
          <Skeleton className="h-8 w-28 rounded-lg" />
        </div>

        <div className="grid gap-6 md:grid-cols-2 md:divide-x md:divide-border">
          <div className="space-y-4 md:pr-6">
            <Skeleton className="h-3 w-28" />
            <div className="space-y-2">
              <Skeleton className="h-2.5 w-20" />
              <Skeleton className="h-3 w-full" />
              <Skeleton className="h-3 w-4/5" />
            </div>
          </div>
          <div className="space-y-4 md:pl-6">
            <Skeleton className="h-3 w-28" />
            <div className="space-y-2">
              <Skeleton className="h-2.5 w-20" />
              <Skeleton className="h-3 w-full" />
              <Skeleton className="h-3 w-4/5" />
            </div>
          </div>
        </div>

        <div className="space-y-3 pt-6 border-t border-border">
          <Skeleton className="h-3 w-40" />
          <div className="flex items-center gap-4">
            <Skeleton className="h-3 w-1/3" />
            <Skeleton className="h-3 w-16" />
            <Skeleton className="h-3 w-16" />
            <Skeleton className="ml-auto h-3 w-20" />
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
